var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedOrangeCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ok_-_check",
    "data-name": "ok - check",
    transform: "translate(21 21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761",
    transform: "translate(-21 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M32.5,3.1A29.4,29.4,0,1,1,3.1,32.5,29.437,29.437,0,0,1,32.5,3.1m0-3.1A32.5,32.5,0,1,0,65,32.5,32.5,32.5,0,0,0,32.5,0Z",
    fill: "#f97f21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pfad_3",
    "data-name": "Pfad 3",
    transform: "translate(15.06 20.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M20.993,37.611a1.529,1.529,0,0,1-1.077-.446L10,27.252A1.524,1.524,0,1,1,12.158,25.1l8.835,8.837L41.607,13.318a1.524,1.524,0,0,1,2.155,2.156L22.07,37.164A1.524,1.524,0,0,1,20.993,37.611Z",
    transform: "translate(-9.558 -12.873)",
    fill: "#f97f21"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedOrangeCircle);
export default __webpack_public_path__ + "static/media/CheckedOrangeCircle.edb93a3ef992160ef5b421559a18841c.svg";
export { ForwardRef as ReactComponent };